import React, { useState, useEffect, createContext, useContext } from "react";
import { UserContext } from "hooks/UserContext";
import bwipjs from "bwip-js";
import RenderPcOrMobile from "../RenderPcOrMobile";
import AccessQrCodePC from "view/pc/accessQrCode/accessQrCode.pc";
import AccessQrCodeMobile from "view/mobile/accessQrCode/accessQrCode.mobile";
import { getAttendanceQRCode } from "api";

export const AccessQrCodeViewContext = createContext({});

export default function AccessQrCode(props) {
	const { onClose } = props;
	const { user } = useContext(UserContext);
	const [open, setOpen] = useState(false);
	const [occupiedOpen, setOccupiedOpen] = useState(false);
	const [updateAlertOpen, setUpdateAlertOpen] = React.useState(false);
	const [isReload, setIsReload] = React.useState(0);
	const [isLocked, setIsLocked] = React.useState(false);
	const [qrcodeImg, setQrcodeImg] = React.useState("");

	const [state, setState] = useState({
		isQrCode: false,
		project: "",
		refNum: "",
		projectList: [],
		remarks: "",
		token: "",
	});
	const { project, projectList, remarks, token, refNum } = state;

	const reportRef = React.useRef(null);

	// const getReportStatus = (projectId) => {
	// 	reportRef.current &&
	// 		reportRef.current.getReportStatus(projectId, (res) => {
	// 			if (res) {
	// 				setIsLocked(true);
	// 			} else {
	// 				setIsLocked(false);
	// 			}
	// 		});
	// };

	const handleSetState = (newState) => {
		setState((s) => ({ ...s, ...newState }));
	};

	const getUserProject = async () => {
		await getAttendanceQRCode()
			.then((res) => {
				const projectQRs = res.data?.projectQrVOList || [];
				if (projectQRs.length <= 0) {
					setUpdateAlertOpen(true);
					return;
				}
				projectQRs.forEach((element) => {
					element.refNum = `${element.refNum} (${element.siteName})`;
				});

				let projectTemp = projectQRs[0] || {};
				if (project) {
					projectTemp = projectQRs.find((item) => {
						return item.projectId === project;
					});
				}

				setOpen(true);
				if (projectTemp?.isOccupied) {
					setOccupiedOpen(true);
				}
				//console.log("getAttendance QRCode =>", projectTemp?.token, projectQRs);
				setTimeout(() => {
					handleSetState({
						isQrCode: true,
						projectList: projectQRs,
						project: projectTemp?.projectId,
						refNum: projectTemp?.refNum,
						token: projectTemp?.token,
						remarks: res.data?.remarks,
					});
				}, 0);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		if (user) {
			if (user?.roles.some((role) => role.toUpperCase().includes("RESEARCHER"))) {
				getUserProject();
			} else {
				onClose();
			}
		}
	}, [user]);

	const createQrCode = async () => {
		try {
			// const qrcodeCanvas = document.querySelector("#qrcode_canvas");
			// bwipjs.toCanvas(qrcodeCanvas, {
			// 	bcid: "qrcode", // Barcode type
			// 	text: token, // Text to encode
			// 	barcolor: "0056AC",
			// 	width: 50,
			// 	height: 50,
			// 	scale: 2,
			// 	includetext: false,
			// });
			const qrcodeCanvas = document.createElement("canvas");
			bwipjs.toCanvas(qrcodeCanvas, {
				bcid: "qrcode", // Barcode type
				text: token, // Text to encode
				barcolor: "0056AC",
				width: 100,
				height: 100,
				scale: 2,
				includetext: false,
			});
			const img = qrcodeCanvas.toDataURL("image/png");
			// console.log("img", img);
			setQrcodeImg(img);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (token) {
			createQrCode();
			// getReportStatus(state?.project);
		}
	}, [token]);

	useEffect(() => {
		isReload && getUserProject();
	}, [isReload]);

	const handleSelect = (v, o) => {
		handleSetState({ project: v });
		setOccupiedOpen(o?.isOccupied);
		setIsReload(isReload + 1);
	};
	const optionsClick = (v, o) => {
		if (project === v) {
			getUserProject();
		}
	};

	// console.log(isQrCode)
	return (
		<AccessQrCodeViewContext.Provider
			value={{
				onClose,
				open,
				occupiedOpen,
				setOccupiedOpen,
				updateAlertOpen,
				setUpdateAlertOpen,
				project,
				projectList,
				remarks,
				token,
				refNum,
				handleSelect,
				optionsClick,
				reportRef,
				isLocked,
				qrcodeImg,
			}}
		>
			<RenderPcOrMobile pc={<AccessQrCodePC />} mobile={<AccessQrCodeMobile />} />
		</AccessQrCodeViewContext.Provider>
	);
}
